export enum CusatScoreField {
  INDUSTRY_EXPERTISE = 'industryExpertise',
  GOALS_ALIGNMENT = 'goalsAlignment',
  COMMUNICATION = 'communication',
  PROACTIVE_APPROACH = 'proactiveApproach',
  PROJECT_LEADERSHIP = 'projectLeadership',
  EXECUTION_QUALITY = 'executionQuality',
  PROJECT_DELIVERABLES = 'projectDeliverables',
}

export const CUSAT_SCORE_FIELDS = Object.values(CusatScoreField);

export type CusatSortField = CusatScoreField | 'accountName' | 'lastUpdatedAt';

export type CusatSortOrder = 'ASC' | 'DESC';

export const CUSAT_SCORE_MIN = 1;
export const CUSAT_SCORE_MAX = 5;
export const CUSAT_SCORE_PATTERN = /^[1-5](\.\d{1,2})?$/;
export const CUSAT_ACCOUNT_NAME_MAX_LENGTH = 30;
export const CUSAT_FEEDBACK_MAX_LENGTH = 3000;
export const CUSAT_PAGE_SIZE = 30;
export const CUSAT_IMPORT_ACCEPT =
  '.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
